import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { RESOURCES } from './resources';

// Langues supportées
// on importe seulement le français pour éviter les warning de i18next
export const SUPPORTED_LANGS = ['fr'] as const;
export type SupportedLang = (typeof SUPPORTED_LANGS)[number];

// Namespaces disponibles — dérivés des ressources pour rester en sync automatiquement
export const NAMESPACES = Object.keys(RESOURCES.fr) as Array<keyof typeof RESOURCES.fr>;
export type Namespace = (typeof NAMESPACES)[number];

export const DEFAULT_LANG: SupportedLang = 'fr';
export const DEFAULT_NS: Namespace = 'common';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // Langues
    supportedLngs: SUPPORTED_LANGS,
    fallbackLng: DEFAULT_LANG,
    lng: localStorage.getItem('i18nextLng') || DEFAULT_LANG,

    // Namespaces
    ns: NAMESPACES,
    defaultNS: DEFAULT_NS,
    fallbackNS: DEFAULT_NS,

    // Ressources embarquées dans le bundle JS (hashé par Vite) — plus de problème
    // de cache navigateur/CDN comme avec l'ancien chargement HTTP depuis public/locales.
    resources: RESOURCES,

    // Détection de la langue
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    },

    // Options
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false // React échappe déjà les valeurs
    },

    // React Suspense : plus nécessaire puisque les ressources sont synchrones,
    // mais on garde la compat des composants existants qui s'y reposent.
    react: {
      useSuspense: true
    }
  });

export default i18n;
